import { useEffect } from "react";
import {
  DOCS_STAFF_MESSAGE_TYPE,
  getParentFrameOrigin,
  isAllowedDocsOrigin,
} from "@/features/help-hub/docs.contract";
import { USER } from "@/config";
import { isAuthorized } from "@/utils/authority";

/**
 * @returns {boolean}
 */
function hasSignedInUser() {
  try {
    return Boolean(JSON.parse(localStorage.getItem(USER) || "null"));
  } catch {
    return false;
  }
}

/**
 * Hidden iframe target used by the docs site to ask whether the current
 * browser session is a superAdmin. Posts a single message to the parent
 * and renders nothing.
 */
export function DocsAccessFrame() {
  useEffect(() => {
    const parentOrigin = getParentFrameOrigin();
    if (!isAllowedDocsOrigin(parentOrigin)) {
      return undefined;
    }

    window.parent.postMessage(
      {
        type: DOCS_STAFF_MESSAGE_TYPE,
        allowed: isAuthorized("superAdmin"),
        signedIn: hasSignedInUser(),
      },
      parentOrigin
    );
    return undefined;
  }, []);

  return null;
}

export default DocsAccessFrame;
